module.exports = __webpack_public_path__ + "media/images/desktop/story-script_tap-bg@2x-e5967dd80f57b08baa8df7f87e817b97.png";